import ResponsivePopupContainerSdk from '../components/ResponsivePopupContainer/corvid/ResponsivePopupContainer.corvid';


const ResponsivePopupContainer = {
  sdk: ResponsivePopupContainerSdk
};


export const components = {
  ['ResponsivePopupContainer']: ResponsivePopupContainer
};

